import { SortOption } from '@toggle/toggle';

import {
  FilterState,
  NewsSearchFilterGroupKeys,
  SharedFilterState,
} from '~/hooks/use-filter-actions/useFilterActions';
import { create } from '~/stores/create-store/createStore';

interface NewsSearchStore extends SharedFilterState<NewsSearchFilterGroupKeys> {
  clearActiveFilters: () => void;
  clearSearch: () => void;
  inputValue: string;
  isInputExpanded: boolean;
  getActiveFiltersCount: () => number;
  mostReadOnly?: boolean;
  setFilterState: (filterState: Partial<FilterState>) => void;
  setInputValue: (value: string) => void;
  setInputExpanded: (isInputExpanded: boolean) => void;
  setSort: (sort_by?: SortOption) => void;
  setMostOnly: (mostReadOnly: boolean) => void;
  sort_by?: SortOption;
}

export const useNewsSearchStore = create<NewsSearchStore>((set, get) => ({
  filterGroups: {
    NEWS_SEARCH_FILTERS: {
      activeFilterOptions: [],
      activeFilters: [],
      allFilters: [],
    },
  },
  setFilterState: filterState => {
    set(prevState => ({
      filterGroups: {
        NEWS_SEARCH_FILTERS: {
          ...prevState.filterGroups.NEWS_SEARCH_FILTERS,
          ...filterState,
        },
      },
    }));
  },
  clearActiveFilters: () => {
    get().setFilterState({
      activeFilterOptions: [],
    });
  },
  getActiveFiltersCount: () =>
    get().filterGroups.NEWS_SEARCH_FILTERS.activeFilterOptions.length,
  inputValue: '',
  setInputValue: inputValue => set({ inputValue }),
  clearSearch: () => set({ inputValue: '' }),
  isInputExpanded: false,
  setInputExpanded: isInputExpanded => set({ isInputExpanded }),
  setSort: sort_by => set({ sort_by }),
  setMostOnly: mostReadOnly => set({ mostReadOnly: mostReadOnly }),
}));
